<template>
 <v-container fill-height>
    <v-row class="text-center" align="center" style="height: 100%;">
      <v-col
              cols="12" >
      <v-card
        elevation="5"          
        class="text-uppercase pl-10 pr-10"
      >
        <v-card-title class="justify-center">Results</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-btn v-on:click="download">Download All Decisions</v-btn>
            </v-col>
          </v-row>
          <v-row>
              <v-col cols="12">
                <h4 class="text-left"> Results Validation:</h4>
              </v-col>
              <v-col cols="12">                 
                <v-data-table
                  :headers="headersValidation"
                  :items="resultsValidation"
                  :items-per-page="5"
                  class="elevation-1"
                ></v-data-table>
              </v-col>          
          </v-row>
            <v-row>
              <v-col cols="12">
                <h4 class="text-left"> User Summary:</h4>
              </v-col>
              <v-col cols="12">                 
                <v-data-table
                  :headers="headersUser"
                  :items="allUsersSessions"
                  :items-per-page="5"
                  class="elevation-1"
                ></v-data-table>
              </v-col>          
          </v-row>
           <v-row>
            <v-col cols="12">
              <h4 class="text-left"> User selection:</h4>
            </v-col>
            <v-col cols="6">                 
              <v-select
                v-model="selectedUserId"
                :items="userCodes"
                item-text="code"
                item-value="id"
                label="User Code"   
                v-on:change="userCodeChanged()"               
              ></v-select> 
            </v-col>
          </v-row>
          <v-row v-if="userSessions.length > 0" >
            <v-col cols="12">
              <h4 class="text-left"> User sessions:</h4>
            </v-col>
            <v-col cols="6">                 
              <v-select
                v-model="selectedSession"
                :items="userSessions"
                item-text="session"
                item-value="session"
                label="Session id"
                v-on:change="userSessionSelected()"        
              ></v-select> 
            </v-col>
          </v-row>
           <v-row v-if="decisions.length > 0">
            <v-col cols="12">
              <h4 class="text-left"> Block Summary:</h4>
            </v-col>
            <v-col cols="12">                 
              <v-data-table
                :headers="headersBlocksSummary"
                :items="blocksSummary"
                :items-per-page="5"
                class="elevation-1"
              ></v-data-table>
            </v-col>          
          </v-row>
          <v-row v-if="decisions.length > 0">
            <v-col cols="12">
              <h4 class="text-left"> Decisions:</h4>
            </v-col>            
            <v-col cols="12">                 
              <v-data-table
                :headers="headers"
                :items="decisions"
                :items-per-page="5"
                class="elevation-1"
              ></v-data-table>
            </v-col>
          </v-row>
          
        </v-card-text>        
      </v-card>  
  </v-col>      
</v-row>
</v-container>
</template>

<script>
  import * as api from '../../tools/api'
  import Papaparse from 'papaparse'

  export default {
    name: 'ResultCard',
    props:["block","title"],
    data: () => ({
         userCodes: [],
         selectedUserId: 0,
         userSessions:[],
         selectedSession: 0,
         numDecisions:0,
         decisions:[],
         blocksSummary:[],
         allUsersSessionsData:[],
         resultsValidationData:[],
         headers: [
          { text: 'Session',value: 'session'},
          { text: 'Serie', value: 'serie' },
          { text: 'Block', value: 'block' },
          { text: 'Target', value: 'target' },
          { text: 'Slider Score', value: 'initial_score' },
          { text: 'User Score', value: 'selected_score' },
          { text: 'Duration', value: 'duration' },
          { text: 'Age', value: 'user.age' },
          { text: 'Code', value: 'user.code' },
          { text: 'Events', value: 'user.events' },
          { text: 'Gender', value: 'user.gender' },
          { text: 'Studies', value: 'user.studies' },
        ],
        headersBlocksSummary:[
          { text: 'block',  value: 'blockName'},
          { text: 'Num Decisions',  value: 'numDecisions'},
          { text: 'Avg Duration',  value: 'avgDuration'},
          { text: 'Sum Duration',    value: 'sumDuration'},
          { text: 'Avg score',    value: 'avgScore'},
        ],
        headersUser:[
          { text: 'id',  value: 'user_id'},
          { text: 'User Code',  value: 'user_code'},
          { text: 'Session Id',  value: 'session'},
          { text: 'Session Date',    value: 'sessionDate'},
        ],
        headersValidation:[
          { text: 'User Code',  value: 'user_code'},
          { text: 'Session Id',  value: 'session'},
          { text: 'Num decisions', value:'decisions'},
          { text: 'Session Date',    value: 'sessionDate'}
        ],
         
    }),
    async mounted(){
      console.log("Results")
      this.userCodes =  await api.getAvailableCodes(this.$store.state.apiUri)
      this.allUsersSessionsData  = await api.getUsersAndSessions(this.$store.state.apiUri)
      this.resultsValidationData = await api.resultsValidaton(this.$store.state.apiUri)
      // console.log(this.$store.state.apiUri,this.$store.state.sessionId)
      // this.results = await api.getDecisionsBySession(this.$store.state.apiUri,this.$store.state.sessionId)      
    },
    methods:{
      async userCodeChanged(){
        console.log("changed user code")
        this.userSessions = await api.getSessionsByUserId(this.$store.state.apiUri,this.selectedUserId)
      },
      async userSessionSelected(){
        console.log("changed user session")
        let resp = await api.getDecisionsBySession(this.$store.state.apiUri,this.selectedSession)
        this.blocksSummary = resp.blocksSummary
        this.decisions = resp.decisions
      },
      async download() {        
        let data = await api.getAllDecisions(this.$store.state.apiUri)
        data = data.map(el =>{
          return this.flatObjectResults(el)
        })
        let text = Papaparse.unparse(data,{header:true,delimiter:','});        
        let filename = 'all_decisions.csv';
        let element = document.createElement('a');

        element.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(text));
        element.setAttribute('download', filename);

        element.style.display = 'none';
        document.body.appendChild(element);

        element.click();
        document.body.removeChild(element);     
      },
      flatObjectResults(obj){
        let out ={}
        for( const k in obj){
          if( typeof(obj[k]) === 'object' ){
            let tmpObj = obj[k]
            Object.keys(tmpObj).forEach(e => {
              out[`${k}.${e}`] = tmpObj[e]
            })
          }else
            out[k] = obj[k]
      }
      return out
      }
    },
    computed:{
      allUsersSessions(){        
        return this.allUsersSessionsData.map(el =>{
          return {
            user_id: el.user_id,
            "user_code": el.user_code,
            session: el.session,
            sessionDate: new Date(el.session).toLocaleString()
          }
        })
      },
      resultsValidation(){        
        return this.resultsValidationData.map(el =>{
          return {
            "user_code": el.user_code,
            session: el.session,
            decisions: el.decisions,
            sessionDate: new Date(el.session).toLocaleString()
          }
        })
      }
    }
  }
</script>
